import TableRowSkeleton from '@components/common/Table/TableRowSkeleton'

const AssetMainDetailsDisplayLoading: React.FC = () => {
  return <TableRowSkeleton height="26px" rows={9} />
}

export default AssetMainDetailsDisplayLoading
